module.exports = __webpack_public_path__ + "static/media/instructions.1018bce6.pdf";